<div class="container m-b-20" fxLayout="row" fxLayoutAlign="end" fxLayoutGap="20px">
  <button
    mat-raised-button
    color="primary"
    [routerLink]="['create']"
    *mifosxHasPermission="'CREATE_ENTITY_DATATABLE_CHECK'"
  >
    <fa-icon icon="plus" class="m-r-10"></fa-icon>
    {{ 'labels.buttons.Create' | translate }}
  </button>
</div>

<div class="container">
  <div fxLayout="row" fxLayoutGap="20px">
    <mat-form-field fxFlex>
      <mat-label>{{ 'labels.inputs.Filter' | translate }}</mat-label>
      <input matInput (keyup)="applyFilter($event.target.value)" />
    </mat-form-field>
  </div>

  <div class="mat-elevation-z8">
    <table mat-table [dataSource]="dataSource" matSort>
      <ng-container matColumnDef="entity">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'labels.inputs.Entity' | translate }}</th>
        <td mat-cell *matCellDef="let entityDataTableCheck">{{ entityDataTableCheck.entity }}</td>
      </ng-container>

      <ng-container matColumnDef="productName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'labels.inputs.Product Name' | translate }}</th>
        <td mat-cell *matCellDef="let entityDataTableCheck">{{ entityDataTableCheck.productName }}</td>
      </ng-container>

      <ng-container matColumnDef="datatableName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'labels.inputs.Data Table' | translate }}</th>
        <td mat-cell *matCellDef="let entityDataTableCheck">{{ entityDataTableCheck.datatableName }}</td>
      </ng-container>

      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'labels.inputs.Status' | translate }}</th>
        <td mat-cell *matCellDef="let entityDataTableCheck">{{ entityDataTableCheck.status.value }}</td>
      </ng-container>

      <ng-container matColumnDef="systemDefined">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'labels.inputs.System Defined' | translate }}</th>
        <td mat-cell *matCellDef="let entityDataTableCheck">
          <div [className]="entityDataTableCheck.systemDefined === true ? 'true' : 'false'">
            <fa-icon
              *ngIf="entityDataTableCheck.systemDefined"
              icon="check-circle"
              size="lg"
              matTooltip="{{ 'tooltips.Yes' | translate }}"
              matTooltipPosition="right"
            ></fa-icon>
            <fa-icon
              *ngIf="!entityDataTableCheck.systemDefined"
              icon="times-circle"
              size="lg"
              matTooltip="{{ 'tooltips.No' | translate }}"
              matTooltipPosition="right"
            ></fa-icon>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef>{{ 'labels.inputs.Actions' | translate }}</th>
        <td mat-cell *matCellDef="let entityDataTableCheck">
          <button
            mat-button
            (click)="deleteEntityDataTableCheck(entityDataTableCheck.id)"
            color="warn"
            *mifosxHasPermission="'DELETE_ENTITY_DATATABLE_CHECK'"
          >
            <fa-icon icon="trash" class="m-r-10"></fa-icon>{{ 'labels.buttons.Delete' | translate }}
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>

    <mat-paginator [pageSizeOptions]="[10, 25, 50, 100]" showFirstLastButtons></mat-paginator>
  </div>
</div>
